import React, { useState } from 'react';
import { ChangeEvent } from 'react';
import { useHistory } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import { toast } from 'react-toastify';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { useStyles } from './styles';
import { Form } from '@unform/web';
import { useLoading } from '../../contexts/loading.context';
import { SIGNIN_ROUTE } from '../../constants'
import { v4 as uuidv4 } from 'uuid';
import {
  findUserByEmail,
  FindUserByEmailParams,
  registerUser,
  userResetPassword,
} from '@bforms-web/common';

export default function ForgetPassword() {
    const classes = useStyles();
    const { showLoading, hideLoading } = useLoading();
    const { push } = useHistory();
    
    const [values, setValues] = useState<FindUserByEmailParams>({
      email: '',
    });

    const handleChange = (prop: keyof FindUserByEmailParams) => (event: ChangeEvent<HTMLInputElement>): void => {
      setValues({ ...values, [prop]: event.target.value });
    };

    const handleSubmit = () => {    
        showLoading();
        async function runAsync() {
          try {
          const user = await findUserByEmail.execute(values)
          if(user){
            user.resetPasswordToken = uuidv4();
            await registerUser.execute({
              ...user,
            });
          await userResetPassword.execute(user)
          }
        } catch (err) {
          
        } finally{
          toast.success('Recuperação de senha enviada, verifique seu email');//sempre avisamos que foi enviado, por motivo de segurança
          hideLoading();
        }
      }
      runAsync()  
    }
  

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Informe seu email cadastrado
        </Typography>
        <Form className={classes.form} onSubmit={handleSubmit}>
          <TextField
            onChange={handleChange('email')}
            name="email"
            required
            variant="outlined"
            margin="normal"
            fullWidth
            label="Seu E-mail"
            autoComplete="email"
            autoFocus
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Enviar Email
          </Button>
              <Button color="primary" onClick={() => { push(SIGNIN_ROUTE) }}>
               {'Voltar'}
              </Button>
        </Form>
      </div>

      <Box mt={8}>
        <Typography variant="body2" align="center" className={classes.span}>
                © 2026
                {' '}
                <a href="https://www.bcare.com.br" target="_blank" rel="noreferrer">
                    bCare
                </a>
                . Todos os direitos reservados.
        </Typography>
      </Box>

    </Container>
  );
}

